import { Helmet } from "react-helmet-async";
import { SEOHelmetProps } from "./SEOHelment-type";


const SEOHelmet: React.FC<SEOHelmetProps> = ({ metadata }) => {
    return (
        <Helmet>
        {metadata.title && <title>{metadata.title}</title>}
        {metadata.description && <meta name="description" content={metadata.description} />}
        {metadata.keywords && <meta name="keywords" content={metadata.keywords} />}
        {metadata.author && <meta name="author" content={metadata.author} />}
        {metadata.robots && <meta name="robots" content={metadata.robots} />}
        {metadata.viewport && <meta name="viewport" content={metadata.viewport} />}
        {metadata.themeColor && <meta name="theme-color" content={metadata.themeColor} />}
        {metadata.favicon && <link rel="icon" href={metadata.favicon} />}
        {metadata.appleTouchIcon && <link rel="apple-touch-icon" href={metadata.appleTouchIcon} />}
        {metadata.msTileImage && <meta name="msapplication-TileImage" content={metadata.msTileImage} />}
        {metadata.msTileColor && <meta name="msapplication-TileColor" content={metadata.msTileColor} />}
    </Helmet>
    );
};

export default SEOHelmet;